import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={companyInfo.logo} 
                alt={companyInfo.name} 
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <h3 className="text-xl font-bold mb-2">FORMATION</h3>
            <h3 className="text-xl font-bold mb-4">DU DRAGON</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Organisme de formation spécialisé en sécurité, incendie et secourisme. 
              Nous proposons des formations adaptées aux besoins des entreprises et organismes.
            </p>
          </div>

          {/* Formations */}
          <div>
            <h4 className="text-lg font-bold mb-6">Nos services</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/prestations" className="text-gray-400 hover:text-red-500 transition-colors">
                  Prestations en organisme
                </Link>
              </li>
              <li>
                <Link to="/formations" className="text-gray-400 hover:text-red-500 transition-colors">
                  Formations internes
                </Link>
              </li>
              <li>
                <Link to="/calendrier" className="text-gray-400 hover:text-red-500 transition-colors">
                  Calendrier des sessions
                </Link>
              </li>
            </ul>
          </div>

          {/* À propos */}
          <div>
            <h4 className="text-lg font-bold mb-6">À propos</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-red-500 transition-colors">
                  Qui sommes-nous
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-red-500 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-400 hover:text-red-500 transition-colors">
                  Nos valeurs
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contactez-nous</h4>
            <div className="space-y-4 text-sm">
              <a 
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} 
                className="flex items-center gap-3 text-gray-400 hover:text-red-500 transition-colors"
              >
                <Phone size={18} />
                <span>{companyInfo.phone}</span>
              </a>
              <a 
                href={`mailto:${companyInfo.email}`} 
                className="flex items-center gap-3 text-gray-400 hover:text-red-500 transition-colors break-all"
              >
                <Mail size={18} />
                <span>{companyInfo.email}</span>
              </a>
            </div>
            <div className="mt-6">
              <Link 
                to="/contact" 
                className="inline-block bg-red-600 text-white px-6 py-2.5 rounded-md hover:bg-red-700 transition-colors font-semibold text-sm"
              >
                DEMANDEZ UN DEVIS
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© 2026 - Formation du Dragon. Tous droits réservés.</p>
            <div className="flex gap-6">
              <Link to="/" className="hover:text-red-500 transition-colors">
                Mentions légales
              </Link>
              <Link to="/" className="hover:text-red-500 transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;